import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchProfileHolidayAllowance = createAsyncThunk(
  'profileHoliday/fetchAllowance',
  async ({ userEmail, employeeId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/ProfileHoliday/userAllowance`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: {
          userEmail,
          ...(employeeId !== undefined && employeeId !== null ? { EmployeeID: employeeId } : {}),
        },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileHoliday/fetchAllowance failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch allowance');
    }
  }
);

export const fetchCalendarData = createAsyncThunk(
  'profileHoliday/fetchCalendarData',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/CalendarData`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileHoliday/fetchCalendarData failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch calendar data');
    }
  }
);

export const fetchCalendarDataWithParams = createAsyncThunk(
  'profileHoliday/fetchCalendarDataWithParams',
  async ({ params }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/CalendarData`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params,
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileHoliday/fetchCalendarDataWithParams failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch calendar data');
    }
  }
);

export const cancelProfileLeaveRequest = createAsyncThunk(
  'profileHoliday/cancelLeave',
  async ({ userEmail, leaveId }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/ProfileHoliday/CancelingLeaveRequest`,
        { userEmail, leaveID: leaveId },
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileHoliday/cancelLeave failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to cancel leave');
    }
  }
);

export const submitProfileLeaveRequest = createAsyncThunk(
  'profileHoliday/submitLeave',
  async ({ bookingDetails }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${API_URL}/api/ProfileHoliday/LeaveRequestSubmit`,
        bookingDetails,
        { signal, headers: { 'Content-Type': 'application/json' } }
      );
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('profileHoliday/submitLeave failed', e);
      return rejectWithValue(e?.response?.data?.message || e?.message || 'Failed to submit leave request');
    }
  }
);

const slice = createSlice({
  name: 'profileHoliday',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('profileHoliday/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


